import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
const NotFound = () => {
    return (
        <div class="text-center">
           <h1 className="text-white">Page not found...404 Error!!!</h1> 
        </div>
    );
};

export default NotFound;